
function isElementInViewport (el) {
  if (typeof jQuery === "function" && el instanceof jQuery) {
    el = el[0];
  }
  let rect = el.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
  );
}

function setImgPixel(){
  if (drupalSettings.widget_agos && drupalSettings.widget_agos.pixel_view_url && !document.querySelector("#pixel-Agos")){
    const el = document.createElement("img");
    let urlPixel = drupalSettings.widget_agos.pixel_view_url;
    const nowTimestamp = (new Date()).getTime();
    urlPixel = urlPixel.replace("$cachebuster$", nowTimestamp);
    el.setAttribute("src", urlPixel);
    el.setAttribute("border", '0');
    el.setAttribute("width", "1");
    el.setAttribute("height", "1");
    el.setAttribute("id", "pixel-Agos");
    document.querySelector("body").appendChild(el);
  }
}

window.addEventListener("load", () => {
  const widgets = document.querySelectorAll(".widget-agos");
  widgets.forEach((widget) => {
    if (widget && widget.getBoundingClientRect().width>0){
      let inited = false;
      window.addEventListener('scroll', function() {
        if ( inited ) {
          return
        }


        if ( isElementInViewport(widget) ) {
          inited = true;
          setImgPixel();
        }
      });
      widget.querySelector("input[type='submit']").addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (drupalSettings.widget_agos && drupalSettings.widget_agos.param_rate && drupalSettings.widget_agos.param_import && drupalSettings.widget_agos.cta_url){
          let ctaUrl = drupalSettings.widget_agos.cta_url;
          ctaUrl = ctaUrl.replace("%IMPORTO%", widget.querySelector("#"+drupalSettings.widget_agos.param_import).value);
          ctaUrl = ctaUrl.replace("%RATE%", widget.querySelector("#"+drupalSettings.widget_agos.param_rate).value);
          window.open(ctaUrl,'_blank');
        }
      });

      if ( isElementInViewport(widget) ) {
        inited = true;
        setImgPixel();
      }
    }
  });

})

